/*
 * Contact slider
 */
class RLM_AnimatedList {
    constructor (wrapper) {
        this.mainWrapper = jQuery(wrapper);
        
        if (!this.mainWrapper.find('.animated-list-js').length) {
            return;
        }
        
        this.initState();
        this.initLists();
    }

    initState () {
        this.win = jQuery(window);
        this.lists = this.mainWrapper.find('.animated-list-js');
        this.interval = 3500;
        this.timeouts = [];
    }

    initLists () {
        for (let i = 0; i < this.lists.length; i++) {
            let list = this.lists.eq(i);
            this.initList(list);
        }
    }

    initList (listWrapper) {
        let self = this;
        let id = parseInt(Math.random() * 9999999999);
        listWrapper.attr('data-id', id)
        let items = listWrapper.find('.animated-list-js-items li');
        
        for (let i = 0; i < items.length; i++) {
            items.eq(i).attr('data-index', i);
            items.eq(i).on('click', function () {
                let nextIndex = $(this).attr('data-index');
                self.animateListTo(listWrapper, nextIndex);
            });
        }

        if (this.win.outerWidth() <= 1040) {
            this.timeouts[id] = setTimeout(() => {
                this.animateList(listWrapper);
            }, 500);
        } else {
            let aosID = listWrapper.find('.animated-list-js-items li').eq(0).attr('data-aos-id');

            document.addEventListener('aos:in:' + aosID, ({ detail }) => {
                if (!listWrapper.hasClass('is-activated')) {
                    listWrapper.addClass('is-activated')
                    this.timeouts[id] = setTimeout(() => {
                        this.animateList(listWrapper);
                    }, 750);
                }
            });
        }
    }

    animateList (listWrapper) {
        let id = listWrapper.attr('data-id');
        let currentIndex = parseInt(listWrapper.attr('data-list-current'), 10);
        let count = parseInt(listWrapper.attr('data-list-count'), 10);
        currentIndex++;

        if (currentIndex === count) {
            currentIndex = 0;
        }

        listWrapper.attr('data-list-current', currentIndex);

        this.timeouts[id] = setTimeout(() => {
            this.animateList(listWrapper);
        }, this.interval);
    }

    animateListTo(listWrapper, index) {
        let id = listWrapper.attr('data-id');
        listWrapper.attr('data-list-current', index);
        clearTimeout(this.timeouts[id]);

        this.timeouts[id] = setTimeout(() => {
            this.animateList(listWrapper);
        }, this.interval);
    }
}

new RLM_AnimatedList(document.body);